(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('LicenseStaffManagerController', LicenseStaffManagerController);

    LicenseStaffManagerController.$inject = ['paginationConstants', 'LicenseService', 'MessageService', 'JigyoushoResourceService', '$uibModal'];

    function LicenseStaffManagerController (paginationConstants, LicenseService, MessageService, JigyoushoResourceService, $uibModal) {

        var vm = this;

        // 翻页所需
        vm.page = 1;
        vm.links = null;
        vm.totalItems = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        // 用户列表
        vm.staffList = [];
        // 事业所list
        vm.jigyoushoList = [];
        // serviceType list
        vm.serviceTypeList = [];
        // license使用数
        vm.licenseUsedList = [];
        // 查询条件
        vm.searchData = {jigyoushoId: "", loginId: "", name: ""};
        vm.defaultSearchData = {jigyoushoId: "", loginId: "", name: ""};

        vm.noGroup = true;

        // 查询serviceType
        vm.loadServiceTypeList = loadServiceTypeList;
        // 初始加载数据
        vm.loadData = loadData;
        // 点击查询
        vm.search = search;
        // 清空搜索条件
        vm.clear = clear;
        // 编辑用户service
        vm.edit = edit;

        // 加载完成之后自动执行
        loadData();
        loadServiceTypeList();

        function loadServiceTypeList() {
            JigyoushoResourceService.serviceTypeList(function(result){
                vm.jigyoushoList = result;
            });
        }

        function loadData() {
            if (vm.searchData.jigyoushoId != '') {
                vm.noJigyousho = false;
                LicenseService.queryStaff({
                    page: vm.page - 1,
                    jigyoushoId: vm.searchData.jigyoushoId,
                    loginId: vm.searchData.loginId,
                    name: vm.searchData.name}, function(result, headers) {
                    vm.totalItems = headers('X-Total-Count');
                    vm.staffList = result;
                });
                LicenseService.houjinLicenseSumByJigyousho({jigyoushoId: vm.searchData.jigyoushoId}, function(result){
                    vm.licenseUsedList = result;
                });
            } else {
                vm.noJigyousho = true;
            }

        }

        function search() {
            vm.page = 1;
            loadData();
        }

        function clear() {
            //vm.defaultSearchData.jigyoushoId = vm.searchData.jigyoushoId;
            vm.searchData = angular.copy(vm.defaultSearchData);
            vm.page = 1;
            loadData();
        }

        function edit(model) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/customer/license/staff/dialog/license-staff-edit-dialog.html',
                controller: 'LicenseStaffEditDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    param: function(){
                        return model;
                    }
                }
            });
            modalInstance.result.then(function() {
                loadData();
            },function(){
                loadData();
            })
        }

    }
})();
